const { styled, Box, Typography } = require("@mui/material");

const ContainerBox = styled(Box)(({ theme, lastIndex }) => ({
  padding: theme.spacing(4),
  backgroundColor: "white",
  margin: theme.spacing(2),
  borderRadius: theme.spacing(1.25),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const RowContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
});

const PaitentContainer = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0.5),
  backgroundColor: "lightgray",
  borderRadius: theme.spacing(1.25),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(2),
}));

export { RowContainer, ContainerBox, PaitentContainer };
